/**
 * Телефон в форме заявки: минимум 10 цифр, пробелы, скобки и дефисы допустимы.
 * Совпадает с проверкой в central (PHONE_MIN_DIGITS в lead.router.js).
 */
export const PHONE_PATTERN = '\\D*(\\d\\D*){10,}';
